import {
  Submissions,
  getBuyerFormId,
  getRsvpFormId,
  isAssignedTickets,
  isTicketed,
} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../hooks/runtime'
import {getBuyerDetails, getBuyerDetailsOld} from '../../selectors/checkout'
import {getDefaultFormValuesOld} from '../../selectors/current-member-details'
import {getEvent} from '../../selectors/event'
import {isWixFormsEnabled} from '../../selectors/events-settings'
import {getPlacedOrder} from '../../selectors/placed-order'
import {getFormSubmissions, getRsvpDetails} from '../../selectors/rsvp'
import c from '../classnames.scss'
import {DISABLED_PREFILLED_FORM_FIELDS} from '../form/constants'
import {Form} from '../form/container'
import {BuyerDetailsForm} from './buyer-details-form'
import s from './buyer-details.scss'
import {BuyerDetailsProps} from './interfaces'
import {getInitialValuesOld} from './utils'

export const BuyerDetails = ({editing, onSubmit}: BuyerDetailsProps) => {
  const {experiments} = useExperiments()

  const buyerDetails = useAppSelector(getBuyerDetails)
  const buyerDetailsOld = useAppSelector(getBuyerDetailsOld)
  const rsvpDetails = useAppSelector(getRsvpDetails)
  const submissions = useAppSelector(getFormSubmissions)
  const defaultFormValuesOld = useAppSelector(getDefaultFormValuesOld)
  const placedOrder = useAppSelector(getPlacedOrder)
  const event = useAppSelector(getEvent)
  const wixFormsEnabled = useAppSelector(state => isWixFormsEnabled(state, experiments))

  const ticketed = isTicketed(event)
  const formId = ticketed ? getBuyerFormId(event) : getRsvpFormId(event)
  const initialValuesOld = getInitialValuesOld({
    ticketed,
    buyerDetails: buyerDetailsOld,
    rsvpDetails,
    defaultFormValues: defaultFormValuesOld,
    order: placedOrder,
  })

  const disabledFields = initialValuesOld.email ? DISABLED_PREFILLED_FORM_FIELDS : []
  const detailsOld = ticketed ? buyerDetailsOld : rsvpDetails
  const details = ticketed ? buyerDetails : submissions
  const assignedTicketsEnabled = ticketed && isAssignedTickets(event)

  return editing ? (
    wixFormsEnabled && formId ? (
      <BuyerDetailsForm onSubmit={onSubmit as (data?: Submissions) => void} />
    ) : (
      <div className={s.container}>
        <Form
          initialValues={initialValuesOld}
          disabledFields={disabledFields}
          hideAdditionalFields={assignedTicketsEnabled}
          onFormSubmit={onSubmit}
        />
      </div>
    )
  ) : (
    <div
      data-hook={DH.CHECKOUT_BUYER_DETAILS}
      className={classNames(s.details, c.formLabelsFont, c.formLabelsColor, s.opaque)}
    >
      <div>
        {detailsOld?.firstName || details?.first_name} {detailsOld?.lastName || details?.last_name}
      </div>
      <div>{detailsOld?.email || details?.email}</div>
    </div>
  )
}
